import validate from "validate.js";

function validator(data = {}, rules = {}, options = { fullMessages: true }) {
  let resultValidation = validate(data, rules, options);
  return resultValidation ? resultValidation : false;
}

export default validator;
export { validator };
